  $('.product-carousel').slick({
    infinite: true,
    centerMode: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    prevArrow: '<button type="button" class="slick-custom-arrow slick-prev"></button>',
    nextArrow: '<button type="button" class="slick-custom-arrow slick-next"></button>',
    responsive: [
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  });

    $('.collection-carousel').slick({
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    prevArrow: '<button type="button" class="slick-custom-arrow slick-prev"></button>',
    nextArrow: '<button type="button" class="slick-custom-arrow slick-next"></button>',
    responsive: [
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 3
        }
      }
    ]
  });

    $('.testimonial-carousel').slick({
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    prevArrow: '<button type="button" class="slick-custom-arrow slick-prev"></button>',
    nextArrow: '<button type="button" class="slick-custom-arrow slick-next"></button>',
    responsive: [
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  });